import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M10 12h3","key":"svg-1"}],["path",{"d":"M14 8h-4v8","key":"svg-2"}]]

const IconSquareLetterF = createReactComponent('outline', 'square-letter-f', 'SquareLetterF', __iconNode);

export default IconSquareLetterF;